module.exports = __webpack_public_path__ + "static/media/Celularplantita2.710cb701.png";